
<template>
  <div>
    <v-stepper v-model="stepper" vertical class="ml-1 mr-1 elevation-0">
      <v-stepper-step :complete="stepper > 1" step="1" :editable="stepper > 1">
        Identificação
      </v-stepper-step>
      <v-stepper-content :complete="stepper > 1" step="1">
        <v-col cols="12">
          <v-card color="white lighten-1" class="mb-2 pa-3" height="">
            <v-form ref="step_1" v-model="is_valid_stp1" lazy-validation>
              <v-text-field v-model="brand.name"
                label="Nome" 
                prepend-icon="mdi-domain" 
                :rules="required" 
              ></v-text-field>
              <v-text-field v-model="brand.contact_attributes.celphone" label="Contato (0800)" prepend-icon="mdi-phone"></v-text-field>
              <v-select 
                :rules="required_array" 
                :items="all_segments" 
                :menu-props="{ top: false, offsetY: true }"
                v-model="brand.segment_ids"
                item-text="name" 
                item-value="id" 
                label="Segmentos" 
                prepend-icon="mdi-information" 
                multiple
              ></v-select>
            </v-form>
          </v-card>
          <v-btn text @click="stepper = 1" disabled><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
          <v-btn text @click="nextStepper(1)"><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
        </v-col>
      </v-stepper-content>
      <v-stepper-step :complete="stepper > 2" step="2" :editable="stepper > 2">
        Códigos do Grupo Cimentão
      </v-stepper-step>
      <v-stepper-content step="2">
        <v-col cols="12">
          
          <v-card color="white lighten-1" class="mb-2 pa-3" height="" elevation="0">
            <v-card-title primary-title>
              Escolha as empresas do grupo
            </v-card-title>
            <v-card-text>
              
              <v-form ref="step_2" v-model="is_valid_stp2" lazy-validation >
                <div v-for="item in selected_companies" v-if="selected_companies.length != 0">
                  <v-text-field 
                    :label="`Código: ${item.attributes.name}`" 
                    v-model="item.attributes.code" 
                    :disabled="!selected_companies.includes(item)" 
                    :rules="selected_companies.includes(item) ? required : []"
                  ></v-text-field>
                </div>
                <div v-if="selected_companies.length == 0">
                  Selecione as empresas para definir os códigos.
                </div>
              </v-form>
              </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn @click="dialog_select_companies = !dialog_select_companies" class="primary" small><v-icon small>mdi-plus</v-icon>Selecionar empresas</v-btn>             <!-- <v-btn @click="selected_companies = []">reset</v-btn> -->
            </v-card-actions>
          </v-card>
          <v-btn text @click="stepper = 1"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
          <v-btn text @click="nextStepper(2)" :disabled="selected_companies.length == 0"><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
        </v-col>
      </v-stepper-content>
      <v-stepper-step step="3" :editable="stepper > 3">
        Dados Bancários
      </v-stepper-step>
      <v-stepper-content step="3">
        <v-col cols="12">
          <v-card color="white" class="mb-2 pa-3">
            <BankAccountForm ref="step_3" :account="brand.account_attributes"></BankAccountForm>
          </v-card>
          <v-btn text @click="stepper = 2"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
          <f-btn save 
            @click="nextStepper(3)" 
          ></f-btn>
        </v-col>
      </v-stepper-content>
    </v-stepper>

    <v-dialog v-model="dialog_select_companies" persistent>
      <v-card color="white lighten-1" height="" elevation="0">
        <v-card-title primary-title>
          Escolha as empresas do grupo
        </v-card-title>
        <v-card-text>
          <v-data-table
            v-model="selected_companies"
            :headers="headers"
            :items="companies"
            item-key="id"
            show-select
            class="elevation-1"
            :loading="loading.companies"
            mobile-breakpoint="1"
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="dialog_select_companies = !dialog_select_companies"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {  mapState, } from 'vuex'
import Api from '@/api/index';
import validations from "@/mixins/validations";

export default {
  name: 'RegisterBrand',
  mixins:[validations],
  props:{
    brands:{
      type: Array,
      default(){return []},
    }
  },
  components:{
    BankAccountForm: () => import("@/_backoffice/_registrations/components/shared/forms/BankAccountForm.vue"),
  },
  data() {
    return {
      loading: {
        companies: false,
      },
      dialog_select_companies: false,
      all_segments: [],
      isChecked: false,
      is_valid_stp1: true,
      is_valid_stp2: true,
      stepper: 1,
      headers: [
        { text: 'Empresa', align: 'left', sortable: true, value: 'attributes.name'},
      ],
      brand: {
        name: '',
        segment_ids: [],
        contact_attributes: {
          celphone: '',
        },
        account_attributes: {
          bank_id: '',
          agency: '',
          number: '',
          name: '',
          CPF: '',
          CNPJ: '',
        },
        brand_company_codes_attributes: [],
        vrt_account_attributes: {
          totalBalance: 0,
          currentBalance: 0,
          futureBalance: 0,
          delayedBalance: 0,
          status_id: 1,
          comment: 'Conta criada'
        },
      },
      
      selected_companies: [],
      companies: []
    }
  },
  methods: {
    getData(){
      this.getSegments();
    },
    nextStepper(stepper){
      if(this.$refs[`step_${stepper}`].validate()){ 
        if(stepper == 3){
          this.submitBrand() 
        }else{
          this.stepper = this.stepper + 1
        }
      } 
    },
    getCompanies(){
      this.loading.companies = true
      Api.Company.index().then(r => {
        this.companies = r.data.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading.companies = false
      })
    },
    getSegments() {
      Api.Supplier.indexSegment().then(req => req.data).then(data => {
        this.all_segments = [...data]
      })
    },
    submitBrand() {
      if (this.$refs.step_3.validate() && this.$refs.step_3.validate() && this.$refs.step_3.validate()) {
        this.swallConfirmation({
          title: `Deseja cadastrar marca?`,
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            let brand = {
              ...this.brand,
              brand_company_codes_attributes: []
            }
            this.selected_companies.forEach(el => {
              brand.brand_company_codes_attributes.push({ "company_id": el.attributes.id, "code": el.attributes.code, 'status_id': 1 });
            });
    
            Api.Supplier.createBrand(brand).then((r) => {
              this.brand.brand_company_codes_attributes = [];
              this.reloadBrand()
              this.addNotification({type: 'success',  msg: 'Marca cadastrada com sucesso!'})
            }).catch((err) => {
              console.log(err)
              this.addNotification({type: 'error',  msg: `Não foi possível criar devido a informações incorretas ou duplicadas no sistema.`})
            })
          }
        })
      } else {
        this.addNotification({type: 'error',  msg: `Preencha todos os campos corretamente.`})
      }
    },
    reloadBrand() {
      this.$refs.step_1.reset()
      this.$refs.step_2.reset()
      this.selected_companies = []
      this.stepper = 1
      this.brand = {
        name: '',
        contact_attributes: {
          celphone: '',
        },
        account_attributes: {
          bank_id: '',
          agency: '',
          number: '',
          name: '',
          CPF: '',
          CNPJ: '',
        },
        brand_company_codes_attributes: [],
        vrt_account_attributes: {
          totalBalance: 0,
          currentBalance: 0,
          futureBalance: 0,
          delayedBalance: 0,
          status_id: 1,
          comment: 'Conta criada'
        },
      }
    },

  },
  mounted() {
    this.getData()
  },
  computed: {
    ...mapState({
      companiesBK: state => state.Company.allCompanies,
    })
  },
  watch: {
    stepper(newValue, oldValue) {
      if(newValue == 2){
        this.getCompanies()
      }
      this.$forceUpdate();
    }
  },
}
</script>

